import React, { useState } from 'react';
import './App.css';
import Banner from './components/Banner';
import SearchForm from './components/SearchForm';
import Results from './components/Results';

import { API_BASE_URL } from './config/api';

function App() {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [hasSearched, setHasSearched] = useState(false);
  const [familyMembers, setFamilyMembers] = useState({});
  const [loadingFamily, setLoadingFamily] = useState({});

  const handleSearch = async (searchData) => {
    setLoading(true);
    setError(null);
    setHasSearched(true);

    try {
      const params = new URLSearchParams();
      
      if (searchData.searchType === 'epic') {
        if (searchData.epic) params.append('epic', searchData.epic);
      } else {
        if (searchData.firstName) params.append('firstName', searchData.firstName);
        if (searchData.middleName) params.append('middleName', searchData.middleName);
        if (searchData.surname) params.append('surname', searchData.surname);
      }

      const response = await fetch(`${API_BASE_URL}/search?${params.toString()}`);
      const data = await response.json();

      if (data.success) {
        setResults(data.results || []);
      } else {
        setError(data.error || 'Search failed');
        setResults([]);
      }
    } catch (err) {
      setError('Failed to connect to server. Please try again.');
      setResults([]);
      console.error('Search error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleFamilySearch = async (familyId) => {
    if (!familyId) return;
    
    setLoadingFamily(prev => ({ ...prev, [familyId]: true }));

    try {
      const response = await fetch(`${API_BASE_URL}/search/family/${familyId}`);
      const data = await response.json();

      if (data.success) {
        setFamilyMembers(prev => ({
          ...prev,
          [familyId]: data.results || []
        }));
      } else {
        setFamilyMembers(prev => ({
          ...prev,
          [familyId]: []
        }));
      }
    } catch (err) {
      console.error('Family search error:', err);
      setFamilyMembers(prev => ({
        ...prev,
        [familyId]: []
      }));
    } finally {
      setLoadingFamily(prev => ({ ...prev, [familyId]: false }));
    }
  };

  return (
    <div className="App">
      <Banner />
      <div className="search-banner">
        <div className="container">
          <h1 className="search-banner-title">मतदार यादीत नाव शोधा</h1>
        </div>
      </div>
      <div className="container">
        <div className="app-content">
          <SearchForm onSearch={handleSearch} loading={loading} />
          
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
          
          <Results 
            results={results} 
            loading={loading} 
            hasSearched={hasSearched}
            onFamilySearch={handleFamilySearch}
            familyMembers={familyMembers}
            loadingFamily={loadingFamily}
          />
        </div>
      </div>
    </div>
  );
}

export default App;
